// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__xSmya","imageUploader":"EGiftCard_imageUploader__1aO-E"};